import React, { useState } from 'react';
import { Button, Tooltip } from '@mui/material';
import StatusPill from './StatusPill';
import CancelAddonPopup from './addons/CancelAddonPopup';
import { useRoleAccess } from '../../../../hooks/useRoleAccess';
import { formatReais } from '../utils/subscriptionFormat';
import styles from './addons/Addons.module.css';

const REMOVE_BLOCKED_TEXT = 'Só a pessoa responsável pela conta ou um administrador pode remover adicionais.';

const STATUS = {
  active: { tone: 'success', text: 'Ativo' },
  trialing: { tone: 'info', text: 'Em teste' },
  canceling: { tone: 'warning', text: 'Cancelamento agendado' },
  past_due: { tone: 'warning', text: 'Pagamento pendente' },
  pending: { tone: 'warning', text: 'Pendente' },
  inactive: { tone: 'error', text: 'Inativo' },
  cancelled: { tone: 'neutral', text: 'Cancelado' },
  canceled: { tone: 'neutral', text: 'Cancelado' },
};

/** Uma linha de adicional contratado, com a remoção (bloqueada para quem não gerencia). */
const AddonSubscriptionCard = ({ addon, onCancelAddon }) => {
  const { canAccess } = useRoleAccess();
  const canRemove = canAccess('subscriptionCancel');

  const [popupOpen, setPopupOpen] = useState(false);
  const [removing, setRemoving] = useState(false);
  const [removed, setRemoved] = useState(null);

  const statusKey = addon.subscription_status?.toLowerCase();
  const status = STATUS[statusKey] || { tone: 'neutral', text: addon.subscription_status || 'Desconhecido' };
  const isCancelled = statusKey === 'cancelled' || statusKey === 'canceling';

  const handleClose = () => {
    setPopupOpen(false);
    setRemoved(null);
  };

  const handleRemove = () => {
    setRemoving(true);
    onCancelAddon(addon.stripe_subscription_id, (result) => {
      setRemoving(false);
      setRemoved(!!result.success);
    });
  };

  return (
    <div className={styles.addon}>
      <div className={styles.addonMain}>
        <div className={styles.addonHead}>
          <span className={styles.addonName}>{addon.plan_name}</span>
          <StatusPill tone={status.tone}>{status.text}</StatusPill>
        </div>
        <span className={styles.addonMeta}>
          {formatReais(addon.price)} /mês
          {!isCancelled && addon.next_due_date && (
            <> · válido até {addon.next_due_date_formatted || 'data não disponível'}</>
          )}
        </span>
      </div>

      {!isCancelled && (
        <Tooltip title={canRemove ? '' : REMOVE_BLOCKED_TEXT} arrow>
          <span>
            <Button
              size="small"
              onClick={() => setPopupOpen(true)}
              disabled={!canRemove}
              sx={{ textTransform: 'none', borderRadius: '10px', color: '#64748B', fontWeight: 600 }}
            >
              Remover
            </Button>
          </span>
        </Tooltip>
      )}

      <CancelAddonPopup
        isOpen={popupOpen}
        onClose={handleClose}
        onConfirm={handleRemove}
        isLoading={removing}
        success={removed}
        addon={addon}
      />
    </div>
  );
};

export default AddonSubscriptionCard;
